import { getCanViewLuxPlusBenefits, getIsEnabledFlightsLuxPlusPreview, getIsFreePreviewLuxPlusMember } from 'luxPlus/selectors/featureToggle'

interface FlightLuxPlusPricingOptions {
  enabled?: boolean
  isBundledFlow?: boolean
}

export function canRequestFlightLuxPlusPricing(state: App.State, options: FlightLuxPlusPricingOptions): boolean {
  const { enabled } = options
  if (!enabled) {
    return false
  }

  return getCanViewLuxPlusBenefits(state) ||
    (getIsFreePreviewLuxPlusMember(state) && getIsEnabledFlightsLuxPlusPreview(state))
}
